// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1ZbOy","buttons":"SendReceipts_buttons__925gv","email":"SendReceipts_email__1Z0FE","bookApptTitle":"SendReceipts_bookApptTitle__2Sa1Y"};